import {EditorSelection} from '@codemirror/state';
import {trimmedBlockRange} from './trim.js';

export function changeByRangeTrimmedBlock(state, textCallback) {
  return changeByRangeTrimmedBlockCursor(state, text => {
    const insert = textCallback(text);
    return {insert, cursor: insert.length};
  });
}

export function changeByRangeTrimmedBlockCursor(state, textCursorCallback) {
  return {
    ...state.changeByRange(range => {
      const {from, to, text} = trimmedBlockRange(state, range);
      const {insert, cursor} = textCursorCallback(text);
      return changeSet({from, to, insert, cursor});
    }),
    userEvent: "input.paste",
  };
}

export function changeSet({from, to, insert, cursor}) {
  return {
    changes: [{from, to, insert}],
    range: EditorSelection.cursor(from + cursor)
  };
}

export function simplePut(state, dispatch, content) {
  dispatch({...state.replaceSelection(content), userEvent: "input.paste"});
}

export function insertSelected(state, prefix, infix, suffix) {
  return state.changeByRange(({from, to}) => ({
    changes: [{from, to, insert: prefix + infix + suffix}],
    range: EditorSelection.range(from + prefix.length, from + prefix.length + infix.length)
  }));
}

export function clearContent({state, dispatch}) {
  dispatch({changes: {from: 0, to: state.doc.length}});
}
